// extracted by mini-css-extract-plugin
export var applicationState = "GameConceptsList-module__applicationState___pbY1N";
export var continueButton = "GameConceptsList-module__continueButton___YAjfm";
export var enrolledContainer = "GameConceptsList-module__enrolledContainer___MDCFt";
export var gameConceptEligible = "GameConceptsList-module__gameConceptEligible___3mJ9N";
export var gameConceptEnrolled = "GameConceptsList-module__gameConceptEnrolled___gZQbS";
export var noGameConceptsMessage = "GameConceptsList-module__noGameConceptsMessage___40GBM";
export var notEligibleText = "GameConceptsList-module__notEligibleText___iQZ3s";
export var successIcon = "GameConceptsList-module__successIcon___BtkKl";
export var successIconContainer = "GameConceptsList-module__successIconContainer___Z2yd+";
export var underReviewText = "GameConceptsList-module__underReviewText___Mn8bc";
export var xpaApplyButton = "GameConceptsList-module__xpaApplyButton___TAiNl";
export var xpaApplyText = "GameConceptsList-module__xpaApplyText___YvsGk";
export var xpaEligibleText = "GameConceptsList-module__xpaEligibleText___Gayjq";
export var xpaEnrolledText = "GameConceptsList-module__xpaEnrolledText___Hdqpm";
export var xpaNotEligible = "GameConceptsList-module__xpaNotEligible___vCyWR";
export var xpaUnderReview = "GameConceptsList-module__xpaUnderReview___rStWm";
export var xpaViewButton = "GameConceptsList-module__xpaViewButton___9DitK";